import { render, staticRenderFns } from "./IndustryTitle.vue?vue&type=template&id=1cad2bc7"
import script from "./IndustryTitle.vue?vue&type=script&lang=js"
export * from "./IndustryTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports